import { setUser as sentrySetUser } from '@sentry/browser';
import { lateinit } from 'engine/utils';
import { Button } from 'components/Button';
import { Component, type JSXProps } from 'engine/index';
import { rpc, setRole, setToken } from 'src/backend';
import { Form, TextField, validator as V } from 'components/FormComponents';
import { LoginSchema, type Login as LoginData } from 'shared/modelTypes/index';
import { navigate } from 'engine/router';
import { showToast, Toast } from 'components/Toast';
import { UserCheck } from 'lucide-static';

export class Login extends Component<JSXProps> {
	element: HTMLDivElement = lateinit;

	override render(): HTMLElement {
		this.element = (
			<div class="flex min-h-full flex-col justify-center bg-white px-6 py-12 dark:bg-gray-950 lg:px-8">
				<div class="sm:mx-auto sm:w-full sm:max-w-sm">
					{/* {this.expired && (
						<div class="mb-3 rounded-md border border-danger-700 p-1 text-lg text-danger-900 empty:hidden dark:border-danger-500 dark:text-danger-400">
							Your session has expired. Sign in to continue.
						</div>
					)} */}

					<img class="mx-auto h-20 w-auto drop-shadow-md" src="/logo.svg" alt="Logo" />
					<h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-100">
						Sign in to your account
					</h2>
				</div>

				<div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
					<Form schema={LoginSchema} onSubmit={this.login.bind(this)} class="space-y-6" action="#" method="POST">
						<TextField name="email" type="email" label="Email" validator={V(LoginSchema.shape.email)} />
						<TextField name="password" type="password" label="Password" validator={V(LoginSchema.shape.password)} />
						<div>
							<div validation-errors class="mb-3 rounded-md p-1 text-danger-900 empty:hidden dark:text-danger-400"></div>
							<Button type="submit">Sign in</Button>
						</div>
					</Form>
				</div>
			</div>
		);

		// if the user was still signed in, sign them out now.
		setToken(undefined);

		return this.element;
	}

	async login(login: LoginData) {
		const res = await rpc.login.query(login);
		if ('token' in res && res.success && res.role) {
			sentrySetUser({ email: login.email, username: res.role });
			setRole(res.role);
			setToken(res.token);
			navigate('/dashboard');
			showToast(<Toast icon={UserCheck} title={`Login successful!`} />, 3000);
		} else {
			this.element.querySelector('[validation-errors]')!.textContent = 'Invalid username or password.';
		}
	}
}
